import { render, staticRenderFns } from "./AnnualReturnPhysicalAddressViewer.vue?vue&type=template&id=6fec7bf2&scoped=true&"
import script from "./AnnualReturnPhysicalAddressViewer.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnPhysicalAddressViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec7bf2",
  null
  
)

export default component.exports